// extracted by css-extract-rspack-plugin
export default {"radioLabel":"_3fd2383e","radioWrapper":"_85c9558b","link":"_6e8135a9"};